<template>
  <article class="QualiscoreFilters" :class="[ alert ? 'QualiscoreFilters_with' : '' ]">

    <div class="QualiscoreFilters_wrapper">

      <div class="QualiscoreFilters_results">
        <!-- <div class="Loader" v-if="onLoad"></div> -->

        <div class="QualiscoreFilters_header_question">Quel est le score de la qualité du logement en France ?
        <button class="QualiscoreFilters_header_question_more" @click="$emit('openPanel', { type: 'qualiscore' })">?</button></div>
        <Average :value="Number(user.qualiscore).toFixed(1)" :label="'Votre score'" v-if="user.qualiscore && user.surveys && user.surveys.qualiscore.completed"/>
        <Average :value="0" :label="`Calculez votre score <i class='far fa-arrow-right'></i>`" v-else/>
        <Average :value="datas.score" :label="filtersSlugs.length > 0 ? 'Score filtré' : 'Score national'" :color="'#1F276D'" />
      </div>

      <div class="QualiscoreFilters_filters">
        <button class="QualiscoreFilters_filters_cta" @click="isOpen = !isOpen" v-if="isMobile" :class="{ 'QualiscoreFilters_filters_cta_open': isOpen }">Filtrer les résultats <i class="far fa-angle-down"></i></button>
        <div class="QualiscoreFilters_filters_choices" v-show="isOpen">
          <p class="QualiscoreFilters_rules">Filtrer les résultats <span>(2 filtres maximum)</span> <i class="Load fad fa-spinner-third" v-if="onLoad"></i></p>
          <button class="QualiscoreFilters_filters_choices_reset" @click="reset" :style="{ visibility: filtersSlugs.length > 0 ? 'visible' : 'hidden'}">Réinitialiser<i class="far fa-redo"></i></button>

          <div class="QualiscoreFilters_filters_choices_field" v-for="(row, index) in filters" :key="index" :class="{ 'QualiscoreFilters_filters_choices_field_buttons': row.type == 'buttons' }">
            <h5 v-if="row.name.length > 2">{{ row.name }}</h5>

            <div class="QualiscoreFilters_filters_choices_field_select" v-if="row.type == 'select'" :class="{ 'QualiscoreFilters_filters_choices_field_select_selected': selectActive }">
              <i class="QualiscoreFilters_filters_choices_field_select_arrow fas fa-sort-down"></i>
              <i class="QualiscoreFilters_filters_choices_field_select_picto fas fa-map-marker-alt"></i>
              <select class="Cta Cta_line Cta_select" :class="{ 'Cta_selected': selectActive }" @change="toggleFilter" data-index="9" v-if="$tools.isTouchDevice()" ref="select">
                <option selected value="remove" disabled>Choisir une région</option>
                <option v-for="(filter, index) in row.filters" :data-slug="filter.slug" data-index="9" :key="index" @click="toggleFilter">{{ filter.name }}</option>
              </select>

              <v-select class="Cta Cta_line Cta_select" :class="{ 'Cta_selected': selectActive }" ref="vselect" v-else :dir="'auto'" :clearable="false" :searchable="false" :options="row.filters" label="name" placeholder="Choisir une région" v-model="select" @input="toggleFilter">
                <template slot="option" slot-scope="option">
                  <li v-html="option.name" :data-slug="option.slug" data-index="9"></li>
                </template>
              </v-select>
            </div>

            <button v-else class="Cta Cta_line" v-for="(filter, i) in row.filters" :data-slug="filter.slug" :data-index="row.id" :key="i" @click="toggleFilter" :data-i="i" :class="{ 'Cta_selected': filtersSlugs.some(e => e.slug === filter.slug)}">{{ filter.name }}</button>
          </div>

        </div>
      </div>
    </div>

  </article>
</template>

<script>
  import scrollUpdate from '@/mixins/scrollUpdate'
  import filtersBlock from '@/mixins/filtersBlock'

  import Average from '@/components/Average'

  import { mapActions, mapState } from 'vuex'

  export default {
    name:"QualiscoreFilters",
    props: [ 'filters', 'data', 'index' ],
    components: { Average },
    mixins: [ filtersBlock, scrollUpdate ],
    computed: {
      ...mapState([
        'user'
      ])
    },
    methods: {
      onResize()
      {
        if(window.innerWidth <= 960){
          this.isMobile = true
          this.isOpen = true
        }
        else{
          this.isMobile = false
          this.isOpen = true
        }
      },
      fetchData()
      {
        this.alert = false
        this.onLoad = true
        let filters = []
        this.filtersSlugs.forEach( el => {
          filters.push(el.slug)
        })

        if(filters.length == 0)
        {
          filters.push('all')
          filters.push('all')
        }
        else if(filters.length == 1)
        {
          filters.push('all')
        }

        this.$api.getSurveyFiltersQualiscore(this.$route.params.slug, filters.join(',') )
        .then(response => {
          console.log(response)
          this.datas = response.data.data
          this.onLoad = false
        })
      }
    }
  }
</script>

<style lang="stylus">
.QualiscoreFilters

  position relative
  width 100%
  max-width 1200px
  margin-bottom 55px
  // margin-top 60px

  @media $medium

    margin-bottom 10px
    margin-top 0px

  &_rules

    position relative
    display table

    @media $xsmall

      font-size 16px!important

    span

      transition color 0.6s $ease

  &_with

    .QualiscoreFilters_rules

      span

        color $red

  .Load

    position absolute
    font-size 18px
    color $red
    top 3px
    left calc(100% + 15px)
    animation rotate 1s linear infinite

    @media $small

      left 90%

  .Loader

    position absolute
    top 0px
    right 0px
    width 13px
    height 13px
    border-width 2px

    @media $medium

      bottom 0px
      top auto
      right 0px

    @media $small

      bottom 0px
      top auto
      right 15px

  &_wrapper

    display flex
    flex-direction row
    align-items stretch
    justify-content space-around
    background: #FFFFFF;
    box-shadow: 0 2px 24px 0 rgba(0,0,0,0.10);
    border-radius: 5px;

    @media $medium

      display block

  &_results

    width 100%
    padding 15px 20px
    margin 30px auto
    box-sizing border-box
    position relative
    max-width 390px
    display flex
    flex-direction column
    justify-content center

    &_lines

      display flex
      flex-direction row
      justify-content space-between
      width calc(35% + 65px)
      box-sizing border-box
      position absolute
      top 0px
      left 0px
      height 100%
      padding-left 20px

      span

        display block
        height 100%
        width 1px
        background-color $blue
        opacity 0.1

    &_row

      display flex
      align-items center
      flex-direction row
      width 100%
      margin-top 15px

      &:last-child

        margin-bottom 15px

      &_answer

        text-align left
        font-family: $f-title
        font-weight normal
        font-size: 14px;
        color: $s1
        line-height: 13px;

      &_calc

        width 35%
        min-width 35%
        position relative
        height 35px
        margin-left 60px
        margin-right 10px

        &_percent

          width 18%
          height 100%
          background: $blue
          position absolute
          top 0px
          right 0px
          overflow hidden
          box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);
          border-radius: 10px 0 0 10px;
          transition width 0.8s $back

          span

            font-size: 14px;
            font-weight bold
            color: white
            text-align right
            position absolute
            top 50%
            right 5px
            transform translateY(-50%)
            letter-spacing: 0;

  &_filters

    max-width 390px
    margin auto auto
    width 100%

    @media $medium

      max-width none

    .Cta

      text-transform none!important

    &_cta

      font-size: 14px;
      color: $blue
      appearance none
      border 0px
      border-top 1px solid $s2
      letter-spacing: 0;
      text-transform none!important
      text-align: center;
      font-family $f-title
      font-weight normal
      height 45px
      width 100%
      background-color white
      cursor pointer

      &_open

        i

          transform rotate(180deg)

      i

        margin-left 5px
        transition 1s $ease

    &_choices

      padding 30px 20px
      box-sizing border-box
      width 100%

      @media $medium

        border-top 1px solid $s2

      p

        font-family: $f-title
        font-weight 500
        font-size: 18px;
        color: $blue
        // margin-bottom 20px
        letter-spacing: -0.3px;
        text-align: left;
        line-height: 22px;

      &_reset

        appearance none
        display block
        background-color transparent
        color $s1
        font-size 14px
        text-align left
        margin-top 10px
        margin-bottom 30px
        text-decoration underline
        cursor pointer
        border 0px
        padding 0px

        i

          margin-left 5px

      &_field

        display flex
        flex-direction row
        flex-wrap wrap
        align-items stretch
        justify-content flex-start
        margin-bottom 5px

        @media $medium

          max-width 360px

        &:last-child

          margin-bottom 0px

        .Cta

          text-transform none!important
          font-size 14px

        &_buttons

          button[data-i="0"]

            margin-right 0px
            border-radius 17px 0px 0px 17px

          button[data-i="1"]

            margin-left 0px
            border-radius 0px 17px 17px 0px
            border-left 0px

        &_select

          position relative
          width 100%
          max-width 285px

          select

            width 100%

          &_arrow

            position absolute
            top calc(50% - 2px)
            font-size 16px
            color $grey
            right 15px
            line-height 16px
            transform translateY(-50%)
            z-index 2
            pointer-events none

          &_picto

            position absolute
            top 50%
            font-size 16px
            color $blue
            left 15px
            z-index 2
            line-height 16px
            transform translateY(-50%)

          &_selected

            .QualiscoreFilters_filters_choices_field_select_arrow, .QualiscoreFilters_filters_choices_field_select_picto

              color white!important

        h5

          width 100%
          display block
          font-family: $f-title
          font-weight normal
          font-size: 14px;
          color: $s1
          margin-bottom 10px
          letter-spacing: 0;
          text-align: left;

        .vs__dropdown-menu

          max-height 100px

        .vs__selected-options, .vs__dropdown-toggle, .vs__selected-options input, .vs__selected-options input::placeholder, .vs__selected

          margin 0px
          padding 0px
          font-size: 14px;
          height 100%
          text-transform none
          color $blue
          border 0px
          background transparent

        .vs__dropdown-option

          font-size: 14px;
          text-transform none
          color $blue

        .vs__dropdown-option--highlight

          background-color $n2

        .vs__actions

          display none

        .Cta

          margin-right 10px
          margin-bottom 10px
          font-size: 14px;
          height 35px
          line-height 30px
          padding 0px 10px
          border-radius: 17px;
          text-transform none

          &_line

            border-color $s2
            min-width auto

            &:hover

              color $blue!important
              background-color white!important
              border-color $s2!important

          &_select

            margin-bottom 0px
            box-sizing border-box
            padding 0px 0px 0px 35px
            text-transform none

            &:hover

              background-color transparent!important

            &.Cta_selected

              color white!important

              .vs__selected-options, .vs__selected, .vs__search

                color white!important

          &_selected, &_selected:hover

            color white!important
            border-color $blue!important
            background-color $blue!important
            box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);
            opacity 1

          &:last-child

            margin-right 0px

  &_header

    width 100%
    box-sizing border-box
    margin auto
    margin-bottom 30px

    @media $medium

      padding 20px 20px 0px 20px
      display flex
      margin 0px
      flex-direction row
      align-items stretch
      justify-content flex-start
      margin-bottom 0px

    &_question

      font-family: $f-title;
      font-weight 500
      font-size: 18px;
      line-height: 22px;
      color: $blue
      text-align left
      letter-spacing: -0.3px;
      margin-bottom 20px
      position relative
      padding-right 40px

      @media $medium

        text-align left
        font-size: 14px;
        line-height: 17px;
        margin-top 0px

      &_more

        position absolute
        padding 0px
        display flex
        flex-direction column
        align-items center
        justify-content center
        transition-delay 0s
        font-family: $f-title
        font-weight 500
        font-size: 14px;
        color: white
        letter-spacing: -0.3px;
        text-align: center;
        line-height: 30px;
        height 30px
        width 30px
        background-color $blue
        border-radius 50%
        padding-left 1px
        right 0px
        top 50%
        transform translateY(-50%)
        border 0px
        cursor pointer
        appearance none
        transition transform 0.4s $ease

        &:hover

          transform translateY(-50%) scale(1.15)

    &_count

      font-family: $f-title;
      font-weight 500
      font-size: 14px;
      color: $red
      display table
      letter-spacing: -0.16px;
      line-height: 14px;
      position relative
      margin auto

      @media $medium

        margin 0px
        margin-right 25px
        top 8px

      &:before

        content ''
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -55%) rotate(-45deg)
        width 31px
        height 31px
        border 1px solid $red

        @media $medium

          height 21px
          width 21px



</style>
